'use client'
import React, { useEffect } from 'react'
import { BsFillArrowUpCircleFill } from 'react-icons/bs'
const ToTop = () => {

    useEffect(() => {
        var upBt = document.getElementById("up");

        window.addEventListener("scroll", scrollFunction);

        function scrollFunction() {
            if (upBt) {
                if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
                    upBt.style.display = "block";
                } else {
                    upBt.style.display = "none";
                }
            }
        }


        function topFunction() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
        upBt?.addEventListener("click", topFunction);
    }, [])

    return (
        <button id="up" className="fixed bottom-6 right-6 cursor-pointer drop-shadow-2xl bg-white rounded-full border-2 border-white text-black z-[100]" >
            <BsFillArrowUpCircleFill size={56} />
        </button>
    )
}

export default ToTop